<template>
  <v-form
    @submit.prevent="submitReferralCode"
    class="d-flex justify-center flex-column"
    :style="{
      width: $vuetify.breakpoint.smAndUp ? '65%' : '100%'
    }"
  >
    <v-card-text class="d-flex flex-column align-center">
      <v-text-field dense v-model="form.referralCode" :label="$t('placeholder.referralCode')" class="stretch-append text-field-styling w-100" :error-messages="referralCodeErrors" outlined rounded />
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mb-5 mx-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit" :loading="loading">{{ $t('next') }}</v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import LeftArrow from '@/assets/icons/left-arrow-circle.svg'
import { localeHelper } from '@/utils'

export default {
  components: { LeftArrow },

  data: () => ({
    loading: false,
    form: {
      referralCode: ''
    },
    submissionErrors: {
      referralCode: ''
    }
  }),
  mounted() {
    this.form.referralCode = this.currentUser.signup_referral_code
    if (this.currentUser.referred_by_agentcode) this.form.referralCode = this.currentUser.referred_by_agentcode
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    referralCodeErrors() {
      const errors = []
      this.submissionErrors.referralCode && errors.push(this.submissionErrors.referralCode)
      return errors
    }
  },

  methods: {
    ...mapMutations('agent', ['saveAgentForm']),
    ...mapActions('common', ['verifyReferralCode']),
    ...mapActions('agent', ['applyAsAgent']),
    async submitReferralCode() {
      this.loading = true
      try {
        if (this.form.referralCode) {
          await this.verifyReferralCode(this.form).then((res) => {
            if (!res.is_valid) {
              throw {
                type: 'referralCode',
                message: 'This is not a valid referral code.'
              }
            } else {
              this.saveAgentForm({ referral_code: this.form.referralCode })
            }
          })
        }
        await this.applyAsAgent()
          .then(() => {
            this.$emit('next-step')
          })
          .catch(({ error_message }) => {
            if (error_message === 'You have submitted the application. Please check your application status!') this.$toast.error(localeHelper.getMessage('error.duplicatedAgentApplication'))
            else this.$toast.error(error_message)
          })
          .finally(() => {
            this.loading = false
          })
      } catch (error) {
        this.submissionErrors[error.type] = error.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
